<template>
  <b-card>
    <div slot="header">
      <strong>Inventario - Crear columna</strong>
      <div class="float-right">
          <router-link
            to="/inventory/columns"
            class="btn btn-secondary mx-0 btn-sm"
            ><i class="fa fa-reply fa-lg"></i> Volver
          </router-link>
        </div>
    </div>
    <div>

      <Form @onAction="storeColum" methodForm="POST" scopeForm="create" />

    </div>
  </b-card>
</template>
<script>

// Generales
import { mapActions, mapMutations, mapState } from "vuex";

// Componentes
import Form from "../components/columns/Form.vue";

export default {

  components: {
    Form,
  },

  beforeMount() {
    this.resetColumn();
  },

  onUnmounted() {
    this.resetColumn();
  },

  async mounted() {
    this.load(false);
  },

  computed: {
    ...mapState("colums", ["column"]),
  },

  methods: {

    ...mapMutations("dashboard", ["load"]),
    ...mapMutations("colums", ["resetColumn"]),

    ...mapActions("colums", ["createColum"]),

    async storeColum() {
      this.$validator.validateAll("create").then(async (result) => {

        if (result) {
          const payload = {
              ...this.column,
              danger_fields_id: this.column.danger_fields_id.map(x => x.id),
              separator_to_grouped_fields: ['', null,'blank-space'].find(x => x === this.column.separator_to_grouped_fields) ? 'blank-space' : this.column.separator_to_grouped_fields
          }
          await this.createColum({ payload, callback: this.callbackStore });            
        }

      });
    },

    callbackStore(success) {
      if(!success) return false;

      this.$router.push("/inventory/columns");
    }
  }
  
};
</script>
